export function assetUrl(path: string): string {
  const base = import.meta.env.BASE_URL || "/";
  const cleanedBase = base.endsWith("/") ? base : `${base}/`;
  const cleanedPath = path.replace(/^\/+/, "");
  return `${cleanedBase}assets/${cleanedPath}`;
}
